const WithTable = ({ component: Component, params }) => {
  return <Component params={params} />;
};

export default WithTable;
